import {
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  UserAddOutlined,
} from '@ant-design/icons';
import { Modal, Button, Row, Col, notification, Space } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import FormularioTerminal from '../app/features/FormularioTerminal';
import useTerminalEmissor from '../core/hooks/useTerminalEmissor';
import useTerminalEmissorServico from '../core/hooks/useTerminalEmissorServico';

const ModalUltimoRetornoServico = (props: {
  idTerminal: string;
  idEmissor?: string;
  quandoFinalizar: () => any;
}) => {
  const [visible, setVisible] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [modalText, setModalText] = useState('Form de cadastro de terminais');
  const [showCreationModal, setShowCreationModal] = useState(false);
  const openCreationModal = useCallback(() => setShowCreationModal(true), []);
  const closeCreationModal = useCallback(() => setShowCreationModal(false), []);
  const parametroUrl = useParams<{ id: string }>();

  //fazer a busca
  const { terminalEmissorServico, fetchterminalEmissorServico } = useTerminalEmissorServico();
  useEffect(() => {
    // chamar consulta do usuario novamente
    fetchterminalEmissorServico(props.idTerminal);
  }, [fetchterminalEmissorServico]);

  return (
    <>
      <Row align={'middle'} gutter={24}>
        <Col xs={24} lg={12}>
          <Button size='small' icon={<EyeOutlined />} onClick={openCreationModal} />
        </Col>
      </Row>
      <Modal
        title='Terminais'
        footer={null}
        visible={showCreationModal}
        onCancel={closeCreationModal}
        destroyOnClose
      >
        <legend
          style={{
            borderBottom: '0',
            borderLeft: '0',
            borderRight: '0',
            fontWeight: 'bold',
            color: '#000',
            fontSize: '14px',
            margin: 0,
          }}
        >
          {'Nfc-e'}
        </legend>
        <div>{terminalEmissorServico ? terminalEmissorServico.ultimoRetorno : ''}</div>
        <legend
          style={{

            borderBottom: '0',
            borderLeft: '0',
            borderRight: '0',
            fontWeight: 'bold',
            color: '#000',
            fontSize: '14px',
            margin: 0,
            marginTop:10
          }}
        >
          {'Nfe'}
        </legend>

        <div>{terminalEmissorServico ? terminalEmissorServico.ultimoRetornoNfe : ''}</div>
      </Modal>
    </>
  );
};

export default ModalUltimoRetornoServico;
